<script setup>
import { FILE_ICONS } from '@/assets/static/file_icons'

 const props = defineProps({
   language: {
     type: String,
     default: 'file-code'
   }
 })

 const getIcon = language => FILE_ICONS[language] || 'fas fa-file-code';
 </script>

 <template>
   <FontAwesomeIcon :icon="getIcon(props.language)" />
 </template>